import "./App.css";
import PageLanding from "./PageLanding/PageLanding";
import PageLogin from "./PageLogin/PageLogin";
import PageSignup from "./PageSignup/PageSignup";
import ProtectedRoute from "./Components/ProtectedRoute";
import PublicRoute from "./Components/PublicRoute";
import PageCostumerProfile from "./PageCostumerProfile/PageCostumerProfile";
import PageProducts from "./PageProducts/PageProducts";
import PageGuidelines from "./PageGuidelines/PageGuidelines";

import PageBag from "./PageBag/PageBag";
import AddProducts from "./AddProducts/AddProducts";
import AddCategory from "./AddCategory/AddCategory";
import AddManufacturer from "./AddManufacturer/AddManufacturer";
import SampleInvoice from "./SampleInvoice/SampleInvoice";
import SampleOrderSlip from "./SampleOrderSlip/SampleOrderSlip";
import AddAnimeSeries from "./AddAnimeSeries/AddAnimeSeries";
import _OrderSummaryGroup from "./Admin/_AdminContent/Contents/_Orders/_OrderContent/_PendingPayment/_OrderSummaryGroup/_OrderSummaryGroup";

import { AppProvider } from "./Components/AppProvider";

import Admin from "./Admin/_admin";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import PageProductFullDetails from "./PageProductFullDetails/PageProductFullDetails";
import PageLearMore from "./PageLearnMore/PageLearnMore";
import PageLearnMore from "./PageLearnMore/PageLearnMore";
import ScrollToTop from "./Components/ScrollToTop";
function App() {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--browser-width",
      window.screen.width + "px",
    );
    document.documentElement.style.setProperty(
      "--browser-height",
      window.screen.height + "px",
    );
  }, [window.orientation]);

  return (
    <div>
      <AppProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/*" element={<PageLanding />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <PageLogin />
                </PublicRoute>
              }
            />
            <Route
              path="/Sign-up"
              element={
                <PublicRoute>
                  <PageSignup />
                </PublicRoute>
              }
            />
            <Route
              path="/customer-profile"
              element={
                <ProtectedRoute>
                  <PageCostumerProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Bag"
              element={
                <ProtectedRoute>
                  <PageBag />
                </ProtectedRoute>
              }
            />
            <Route path="/guidelines" element={<PageGuidelines />} />
            <Route path="/learnmore" element={<PageLearnMore />} />
            <Route path="/products" element={<PageProducts />} />
            <Route
              path="/products/:productId"
              element={<PageProductFullDetails />}
            />

            <Route path="/add-product" element={<AddProducts />} />
            <Route path="/add-category" element={<AddCategory />} />
            <Route path="/add-manufacturer" element={<AddManufacturer />} />
            <Route path="/add-anime-series" element={<AddAnimeSeries />} />

            <Route path="/LKI/*" element={<Admin />} />
            <Route
              path="/lki/payment-details/"
              element={<_OrderSummaryGroup />}
            />

            <Route path="/invoice" element={<SampleInvoice />} />
            <Route path="/orderslip" element={<SampleOrderSlip />} />
          </Routes>
        </Router>
      </AppProvider>
    </div>
  );
}

export default App;
